export interface CustomEvent {
	target?: {};
	type: string;
	context?: {};
	data?: {};
}

interface Listeners<T> {
	[key: number]: T;
}

type EventCallback = (event: CustomEvent) => void;
type EventsListeners = Listeners<Array<EventCallback>>;

export class ApiEvents {

	public listeners: EventsListeners = {} as EventsListeners;
	public iName: string;
	constructor() {
		this.iName = 'ApiEvent';
	}

	public addListener(type: string, listener: EventCallback): void {
		if (typeof this.listeners[type] === 'undefined') {
			this.listeners[type] = [];
		}

		if (!this.listeners[type].includes(listener)) {
			this.listeners[type].push(listener);
		}
	}

	public fire(event: CustomEvent): void {
		let i: number = 0;
		let L: number = 0;
		let listeners: Array<EventCallback>;
		let listenersClone: Array<EventCallback>;

		if (!event.target) {
			event.target = this;
		}

		if (!event.context) {
			event.context = this;
		}


		if (this.listeners[event.type] instanceof Array) {
			listeners = this.listeners[event.type];
			listenersClone = [];
			let action;
			L = listeners.length;

			for (; i < L; i++) {
				listenersClone.push(listeners[i]);
			}

			while (action = listenersClone.shift()) {
				if (listeners.includes(action)) {
					action(event);
				}
			}
		}
	}

	public removeListener(type: string, listener: EventCallback): void {
		let L: number = 0;
		let i: number = 0;
		let listeners: Array<EventCallback>;

		if (this.listeners[type] instanceof Array) {
			listeners = this.listeners[type];
			L = listeners.length;
			for (; i < L; i++) {
				if (listener !== null && listeners[i] === listener) {
					listeners.splice(i, 1);
					break;
				} else if (listener === null) {
					listeners.splice(i, 1);
				}
			}
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/iframeApi/ApiEvents.ts